export default __webpack_public_path__ + "static/43aa-b2d826c7fc124dd81d9b794d938af26c.png";